export default [
    '/marketing/calendar',
    '/templates/create',
    '/marketingplans',
    '/clients/:clientId/marketing/calendar',
    '/clients/:clientId/templates/create',
    '/clients/:clientId/marketingplans'
];